import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { api, MONTHS } from "@/lib/api";

const time = (iso) => (iso ? new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }) : "—");
const day = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short", day: "2-digit", month: "short" });

export const MyAttendance = () => {
  const now = new Date();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/attendance/me", { params: { month: now.getMonth() + 1, year: now.getFullYear() } }).then((r) => setRows(r.data));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section>
      <h2 className="font-heading text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
        <Clock className="h-4 w-4 text-sky-600" />Daily Login / Logout · {MONTHS[now.getMonth()]}
      </h2>
      <div className="bg-white border rounded-xl divide-y" data-testid="my-attendance-list">
        <div className="grid grid-cols-4 px-4 py-2 text-[10px] uppercase tracking-wider font-semibold text-slate-500">
          <span>Date</span><span>Login</span><span>Logout</span><span className="text-right">Hours</span>
        </div>
        {rows.length === 0 && <div className="text-sm text-slate-500 text-center p-5">No attendance this month yet.</div>}
        {rows.map((r) => (
          <div key={r.work_date} className="grid grid-cols-4 px-4 py-2.5 text-sm" data-testid={`my-attendance-${r.work_date}`}>
            <span className="font-semibold text-slate-800">{day(r.work_date)}</span>
            <span className="font-mono-num text-emerald-700">{time(r.clock_in_time)}</span>
            <span className="font-mono-num text-rose-600">{time(r.clock_out_time)}</span>
            <span className="font-mono-num text-right text-slate-700">{r.total_hours_worked ?? (r.clock_in_time && !r.clock_out_time ? "On duty" : "—")}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
